import React from 'react'

const Blog = () => {
  return (
    <div>
        <h1>hii</h1>
    </div>
  )
}

export default Blog